<script>
import OrdersApi from "@/services/orders-api";
import Order from "@/components/orderComponent"

export default {
    components: {
        Order
    },
    props: {
        orderId: {
            type: Number,
            default: 0,
        },

        warningMessage: {
            type: String,
            default: null,
        },

  },
    mounted(){
    this.role=sessionStorage.getItem("userr");
    this.getCustomerDeliveryAddresses();
    this.getDeliveryModes();
 
  },
  data (){
      return{
          optionsDeliveryAddresses: [],
          selectedDeliveryAddress: null,

          optionsDeliveryModes: [],
          selectedDeliveryMode: null,

          orderMessage: '',
          isSubmittingOrder:false,


      }
  },
  methods:{

    getCustomerDeliveryAddresses(){
      OrdersApi.getCustomerDeliveryAddresses().then(
        (result)=>{
          if(result){
            this.optionsDeliveryAddresses=result
            if(this.optionsDeliveryAddresses.length){
              this.selectedDeliveryAddress=this.optionsDeliveryAddresses[0]
            }
          }

        }
      )
    },

    getDeliveryModes(){
      OrdersApi.getDeliveryModes().then(
        (result)=>{
          if(result){
            this.optionsDeliveryModes=result
            if(this.optionsDeliveryModes.length){
              this.selectedDeliveryMode=this.optionsDeliveryModes[0]
            }
          }

        }
      )
    },


      submitOrder() {
      this.isSubmittingOrder = true;
      OrdersApi.submitOrder(this.orderId, this.orderMessage, 
      this.selectedPriority==null ? null : this.selectedPriority.value, 
      this.selectedDeliveryAddress==null ? null : this.selectedDeliveryAddress.id,
      false,this.desiredDeliveryDate,this.promotionCode, this.selectedDeliveryMode == null ? null : this.selectedDeliveryMode.extId)
      .then(isSubmitted => {
            if(isSubmitted) {
              this.isSubmittingOrder = false;
              this.$emit('update', true)
            }
        })
      .finally(() => {
        this.isSubmittingOrder = false; 
      })
    },

  }
}
</script>
<template>
<div>
    
      <div class="row pr-4 pl-4 pb-4 pt-2 d-print-none">
        <div class="col-12">
          <div
            v-if="warningMessage"
            class="custom-warning mb-4"
            role="alert"
          >
            <div class="custom-warning-icon">
              <i class="mdi mdi-alert-circle-outline"></i>
            </div>

            <div class="custom-warning-content">
              <div class="custom-warning-message">
                {{ warningMessage }}
              </div>
            </div>
          </div>
          <form class="form-horizontal" role="form">
           
            <div class="form-group row">
              <!-- <label class="col-md-2 col-form-label font-size-14">{{$t('ordersDetailsModal.body.address.label')}}</label> -->
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 pr-sm-2 pr-0">
                <label class="font-size-14">{{$t('ordersDetailsModal.body.address.label')}}</label>
                <v-select class="pb-2 font-size-16"   :options="optionsDeliveryAddresses" v-model="selectedDeliveryAddress" :placeholder="$t('ordersDetailsModal.body.address.placeholder')" label="address" >
                    <span slot="no-options">{{$t("lists.emptyLists.label")}}</span>
                </v-select> 
              </div>

              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 pl-sm-2 pl-0">
                <label class="font-size-14">Mode de Livraison</label>
                <v-select class="pb-2 font-size-16"   :options="optionsDeliveryModes" v-model="selectedDeliveryMode" placeholder="Sélectionner un mode de livraison" label="name" >
                    <span slot="no-options">{{$t("lists.emptyLists.label")}}</span>
                </v-select> 
              </div>

            </div>        
        
        
            <div class="form-group row mb-0">
              <label class="col-md-2 col-form-label font-size-14">{{$t('ordersDetailsModal.body.message.label')}}</label>
              <div class="col-md-12">
                  
                  <textarea
                    v-model="orderMessage"
                    class="form-control"
                    :maxlength="255"
                    rows="3"
                    :placeholder="$t('ordersDetailsModal.body.message.placeholder')"
                  ></textarea>
                  <div class="text-center">
                    <p
                      v-if="orderMessage"
                      class="badge position-absolute"
                      :class="{ 'badge-success': orderMessage.length !== 255,
                                'badge-danger': orderMessage.length === 255 }"
                    >
                      {{ orderMessage.length }} /
                      255
                    </p>
                  </div>
              </div>
            </div>

          </form>
        </div>
      </div>



      <Order class="mt-4" :orderId= this.orderId :isCatalogList=true  :deliveryAddress="selectedDeliveryAddress==null ? null : selectedDeliveryAddress.address" :deliveryMode="selectedDeliveryMode==null ? null : selectedDeliveryMode.name" /> 


      <div class="row p-4 d-print-none" >
          <div class="col-md-4 col-sm-12 "/>
          <div class="col-md-4 col-sm-12 "/>
          <div class="col-md-4 col-sm-12 d-print-none pr-0 ">
              <b-button variant="warning" style="width:100%" size="lg" @click="submitOrder()" :disabled="isSubmittingOrder" >
                  <i class="fas fa-paper-plane font-size-18 align-middle mr-2"></i> <span class="font-weight-bold font-size-14">{{$t('ordersDetailsModal.submitOrder')}} </span>
              </b-button>
          </div>
      </div> 
</div>
</template>


<style scoped>

.custom-warning {
  display: flex;
  align-items: center;
  padding: 14px 18px;
  border: 1px solid #f5b5b5;
  border-radius: 10px;
  background: #fff5f5;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.05);
}

.custom-warning-icon {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 38px;
  height: 38px;
  min-width: 38px;

  margin-right: 13px;

  border-radius: 50%;
  background: #fde0e0;
  color: #c0392b;

  font-size: 21px;
}

.custom-warning-content {
  flex: 1;
}

.custom-warning-message {
  color: #c0392b;
  font-size: 14px;
  line-height: 1.5;
  font-weight: 500;
}

@keyframes warningFadeIn {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.custom-warning {
  animation: warningFadeIn 0.25s ease-out;
}
</style>